// components/ProjectMicroservices.jsx
import React, { useState } from 'react';
import {
  Container,
  Header,
  Table,
  SpaceBetween,
  Box,
  StatusIndicator,
  ButtonDropdown,
  Modal,
  FormField,
  Select,
  Button,
  Link,
  Alert
} from '@cloudscape-design/components';

const ProjectMicroservices = ({ project, onBack, onSelectMicroservice }) => {
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);

  return (
    <SpaceBetween size="l">
      <Container
        header={
          <Header
            variant="h2"
            description={`Generated microservices for ${project.name}`}
            actions={
              <Button
                variant="primary"
                onClick={() => setShowGenerateModal(true)}
              >
                Generate New Microservice
              </Button>
            }
          >
            Project Microservices
          </Header>
        }
      >
        <Table
          columnDefinitions={[
            {
              id: 'name',
              header: 'Service name',
              cell: item => (
                <Link onFollow={() => onSelectMicroservice(item)}>
                  {item.name}
                </Link>
              )
            },
            {
              id: 'domain',
              header: 'Source Domain',
              cell: item => item.domain
            },
            {
              id: 'status',
              header: 'Status',
              cell: item => (
                <StatusIndicator type={
                  item.status === 'GENERATED' ? 'success' :
                  item.status === 'IN_PROGRESS' ? 'in-progress' :
                  'pending'
                }>
                  {item.status}
                </StatusIndicator>
              )
            },
            {
              id: 'repository',
              header: 'Repository',
              cell: item => item.repository && (
                <Link href={`https://${item.repository}`} external>
                  {item.repository}
                </Link>
              )
            },
            {
              id: 'actions',
              header: 'Actions',
              cell: item => (
                <ButtonDropdown
                  items={[
                    { text: 'View code', id: 'code' },
                    { text: 'View pipeline', id: 'pipeline' },
                    { text: 'Download as ZIP', id: 'download' },
                    { text: 'View API docs', id: 'api' }
                  ]}
                >
                  Actions
                </ButtonDropdown>
              )
            }
          ]}
          items={project.microservices}
          loading={false}
          loadingText="Loading microservices"
          variant="container"
        />
      </Container>

      {/* Generate New Microservice Modal */}
      <Modal
        visible={showGenerateModal}
        onDismiss={() => setShowGenerateModal(false)}
        header="Generate New Microservice"
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button
                variant="link"
                onClick={() => setShowGenerateModal(false)}
              >
                Cancel
              </Button>
              <Button variant="primary">
                Generate
              </Button>
            </SpaceBetween>
          </Box>
        }
      >
        <SpaceBetween size="l">
          <Alert type="info">
            Select a domain from the final architecture to generate a new microservice.
            The service will be generated with basic CRUD operations and required configurations.
          </Alert>
          <FormField label="Select Domain">
            <Select
              selectedOption={selectedDomain}
              onChange={({ detail }) => setSelectedDomain(detail.selectedOption)}
              options={[
                { label: 'CustomerDomain', value: 'customer' },
                { label: 'OrderDomain', value: 'order' },
                { label: 'CatalogDomain', value: 'catalog' }
              ]}
            />
          </FormField>
        </SpaceBetween>
      </Modal>
    </SpaceBetween>
  );
};

export default ProjectMicroservices;
